export { default } from "./AppLink";
export type { AppLinkProps } from "./AppLink";
